import { useEffect, useState } from 'react';
import { describeError, logger } from 'utils/logger';

const useCameras = (): MediaDeviceInfo[] => {
  const [cameras, setCameras] = useState<MediaDeviceInfo[]>([]);

  useEffect(() => {
    (async () => {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        const videoDevices = devices.filter(
          (device) => device.kind === 'videoinput',
        );
        logger.info('cameras_found', { count: videoDevices.length });
        videoDevices && setCameras(videoDevices);
      } catch (e) {
        logger.error('cameras_enumerate_failed', { error: describeError(e) });
      }
    })();
  }, []);
  return cameras;
};

export default useCameras;
